module.exports = __webpack_public_path__ + "img/var.d0017acb.jpg";